import React, { CSSProperties, ReactNode, useMemo } from "react";

export default function GridItem(props: {
  left: ReactNode;
  right: ReactNode;
  pattern: "40% 60%" | "60% 40%";
}) {
  const style = useMemo<CSSProperties>(() => {
    return {
      display: "grid",
      gridTemplateColumns: props.pattern,
      gridAutoRows: "auto"
    };
  }, [props.pattern]);

  return (
    <div style={style}>
      <div style={{ gridColumn: 1, gridRow: 1 }}>{props.left}</div>
      <div style={{ gridColumn: 2, gridRow: 1 }}>{props.right}</div>
    </div>
  );
}
